import script from "./InternalProductManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalProductManagement.vue?vue&type=script&setup=true&lang=js"

import "./InternalProductManagement.vue?vue&type=style&index=0&id=7cd6849e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd6849e"]])

export default __exports__